"use client";

import { getPixelId, initFacebookPixel, initPixelIdFromUrl } from "@/lib/facebook-pixel";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

export function FacebookPixel() {
    const pathname = usePathname();
    const pixelIdRef = useRef<string>( "" );

    useEffect( () => {
        // 首次挂载：从 URL 提取或从 localStorage 读取 pixelid，并初始化脚本
        const pixelId = initPixelIdFromUrl();
        if ( !pixelId ) return;
        pixelIdRef.current = pixelId;
        initFacebookPixel( pixelId );
    }, [] );

    useEffect( () => {
        // 路由切换时发送 PageView 事件
        if ( !pixelIdRef.current ) {
            pixelIdRef.current = getPixelId();
        }
        if ( pixelIdRef.current && typeof window !== "undefined" && window.fbq ) {
            window.fbq( "track", "PageView" );
        }
    }, [ pathname ] );

    const pixelId = typeof window !== "undefined" ? getPixelId() : "";

    if ( !pixelId ) return null;

    return (
        <noscript>
            {}
            <img
                height="1"
                width="1"
                style={{ display: "none" }}
                src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
                alt=""
            />
        </noscript>
    );
}
